import { render, staticRenderFns } from "./onboarding-video.vue?vue&type=template&id=d01902c4"
import script from "./onboarding-video.vue?vue&type=script&lang=js"
export * from "./onboarding-video.vue?vue&type=script&lang=js"
import style0 from "./onboarding-video.vue?vue&type=style&index=0&id=d01902c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports